import { useState, createContext, useContext, useMemo } from 'react'
import { useQueryResponse, useQueryResponseData } from './response'
import {
    calculatedGroupingIsDisabled,
    calculateIsAllDataSelected,
    groupingOnSelectAll,
} from '../../_metronic/helpers'
const initialListView = {
    selected: [],
    selectedItem: [],
    redemitem: {},
    step: 0,
    onSelect: () => { },
    onItem: () => { },
    addPointRedem: () => { },
    onSelectAll: () => { },
    onItemRemove: () => { },
    rowAttributeUpadte: () => { },
    clearSelected: () => { },
    setItemIdForUpdate: () => { },
    setStep: () => { },
    //setViewPage: () => { },
    isAllSelected: false,
    disabled: false,
    view: false
}

const ListViewContext = createContext(initialListView)

/**
 * ListViewProvider
 *
 * Provides context for managing selected items, redemption points, and view state in tables.
 * Handles selection, item updates, removal, and bulk actions.
 *
 * Props:
 * - children: React children components
 */

const ListViewProvider = ({ children }) => {
    const [selected, setSelected] = useState(initialListView.selected)
    const [redemItem, setRedemItem] = useState(initialListView.redemitem)
    const [itemIdForUpdate, setItemIdForUpdate] = useState(initialListView.itemIdForUpdate)
    const [view, setViewPage] = useState(initialListView.view)
    const { isLoading } = useQueryResponse()
    const data = useQueryResponseData()

    //const EditRow = data.filter(x => x.id === itemIdForUpdate);
    const disabled = useMemo(() => calculatedGroupingIsDisabled(isLoading, data), [isLoading, data])
    const isAllSelected = useMemo(() => calculateIsAllDataSelected(data, selected), [data, selected])

    const groupingOnSelectItem = (row) => {

        const updatedSelected = [...selected];
        const isExitItem = updatedSelected.filter(x => x.id === row.id);
        if (isExitItem.length > 0) {
            setSelected(selected.filter((item) => item.id !== row.id))
        } else {
            updatedSelected.push(row)
            setSelected(updatedSelected)
        }

    }
    // const addItem = (row) => {
    //     const updatedSelected = [];
    //     updatedSelected.push(row)
    //     setSelected(updatedSelected)

    // }
    const addItem = (row) => {

        const updatedSelected = [...selected];
        const itemIndex = updatedSelected.findIndex((item) => item.id === row.id);

        if (itemIndex > -1) {
            // Item exists, update it
            updatedSelected[itemIndex] = row;
        } else {
            // Item does not exist, add it
            updatedSelected.push(row);
        }

        setSelected(updatedSelected);
    };

    const itemRemove = (row) => {
        const updatedSelected = [...selected];
        const isExitItem = updatedSelected.filter(x => x.id === row.id);
        if (isExitItem.length > 0) {
            setSelected(selected.filter((item) => item.id !== row.id))
        } else {
            updatedSelected.push(row)
            setSelected(updatedSelected)
        }
    };
    const updateRow = (row) => {
        const updatedSelected = [...selected];
        const itemIndex = updatedSelected.findIndex((item) => item.id === row.id);
        if (itemIndex > -1) {
            // Item exists, update it
            updatedSelected[itemIndex] = row;
            setSelected(updatedSelected)
        }
    }

    const redemPoint = (row) => {
        setRedemItem(row)
    }
    return (
        <ListViewContext.Provider
            value={{
                redemItem,
                selected,
                itemIdForUpdate,
                setItemIdForUpdate,
                setViewPage,
                view,
                disabled,
                isAllSelected,
                onSelect: (row) => {
                    ///groupingOnSelect(row, selected, setSelected)
                    groupingOnSelectItem(row)
                },
                rowAttributeUpadte: (row) => {
                    updateRow(row)
                },
                addPointRedem: (row) => {
                    redemPoint(row)
                },
                onSelectAll: () => {
                    groupingOnSelectAll(isAllSelected, setSelected, data)
                },

                clearSelected: () => {
                    setSelected([])
                },
                clearSetRedemItem: () => {
                    setRedemItem()
                },
                onItem: (row) => {
                    addItem(row)
                },
                onItemRemove: (row) => {
                    itemRemove(row)
                }
            }}
        >
            {children}
        </ListViewContext.Provider>
    )
}

/**
 * useListView
 *
 * Returns the current list view context for accessing selection and actions.
 */

const useListView = () => useContext(ListViewContext)

export { ListViewProvider, useListView }
